// extracted by mini-css-extract-plugin
module.exports = {"root":"text-root-o5a","cmsContent":"text-cmsContent-TZt"};